

















































































import {
  CreateDocumentAbbreviationModel,
  DocumentAbbreviationModel,
  DocumentAbbreviationsClient,
  UpdateDocumentAbbreviationValueModel
} from "@/api/OtiumAppApi";
import { useProjectStore } from "@/stores/projectStore";
import { defineComponent, ref, watch } from "@vue/composition-api";

export default defineComponent({
  props: {
    openedDialogs: {
      type: Object,
      required: true
    },
    editingAbbreviation: {
      type: DocumentAbbreviationModel
    }
  },
  setup(props, context) {
    const projectStore = useProjectStore();
    const editAbbreviationValue = ref("");
    watch(
      () => props.editingAbbreviation,
      (newValue) => {
        if (newValue) {
          editAbbreviationValue.value = newValue.version.value;
        }
      }
    );

    const newAbbreviationValue = ref("");
    const newAbbreviationName = ref("");

    const savingNewAbbreviation = ref(false);
    const saveNewAbbreviation = async () => {
      if (!projectStore.documentVersionIdInContext) return;
      savingNewAbbreviation.value = true;

      const client = new DocumentAbbreviationsClient();
      await client.createAbbreviation(projectStore.documentVersionIdInContext, {
        value: newAbbreviationValue.value,
        name: newAbbreviationName.value
      } as CreateDocumentAbbreviationModel);

      savingNewAbbreviation.value = false;
      props.openedDialogs.add = false;
      newAbbreviationValue.value = "";
      newAbbreviationName.value = "";
    };

    const savingEditAbbreviation = ref(false);
    const saveEditAbbreviation = async () => {
      if (!props.editingAbbreviation) return;
      savingEditAbbreviation.value = true;
      const client = new DocumentAbbreviationsClient();
      await client.updateAbbreviation(props.editingAbbreviation.id, {
        value: editAbbreviationValue.value
      } as UpdateDocumentAbbreviationValueModel);

      savingEditAbbreviation.value = false;
      props.openedDialogs.edit = false;
    };

    return {
      projectStore,
      editAbbreviationValue,
      savingEditAbbreviation,
      saveEditAbbreviation,

      newAbbreviationName,
      newAbbreviationValue,
      savingNewAbbreviation,
      saveNewAbbreviation
    };
  }
});
